import React from 'react';
import { IconProps } from '.';

type Props = IconProps & {
  className?: string;
};

export default function Add({ color, className }: Props) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.4054 5.30067H9.13953V0H5.23556V5.30067H0V9.10469H5.23556V14.4054H9.13953V9.10469H14.4054V5.30067Z"
        fill={color ?? '#fff'}
      />
    </svg>
  );
}
